import { styled } from '@mui/material';

import { generateClasses } from '../../../../../../../utils/helper';

export const pieChartClasses = generateClasses('PieChart', ['chart', 'slice']);

export const Svg = styled('svg')(({ theme }) => ({
  [`& .${pieChartClasses.chart}:hover > .${pieChartClasses.slice}`]: {
    opacity: 0.2,
    '&:hover': {
      opacity: 1,
    },
  },
  [`& .${pieChartClasses.slice}, & .${pieChartClasses.slice} > *`]: {
    transition: 'opacity 300ms ease-out',
  },
}));
